import { ReactNode, useContext, useMemo } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import UserContext from '~/context/common/UserContext';
import NewPriceIcon from '~/icons/NewPriceIcon';
import FilledPlugIcon from './icons/FilledPlugIcon';
import FreeShippingIcon from './icons/FreeShippingIcon';
import TagIcon from './icons/TagIcon';

export type SuggestedSearch = {
  Icon?: ReactNode;
  title: string;
  link: string;
};

function SuggestedImage({ vehicle }: { vehicle: string }) {
  return (
    <img
      alt={vehicle}
      src={`${process.env.CVNA_APP_CDN_URL}/home-assets/nba/${vehicle}.png?width=48`}
      height={24}
      width={48}
    />
  );
}

export default function useGetSuggestedSearches(): SuggestedSearch[] {
  const {
    location: {
      data: { state }
    }
  } = useContext(UserContext);
  const { priceDropRestrictedStates } = useConfiguration();
  const isInRestrictedState =
    !priceDropRestrictedStates || priceDropRestrictedStates.includes(state);

  return useMemo(
    () => [
      {
        Icon: <TagIcon />,
        title: 'Shop Great Deals',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7InRhZ0lkcyI6WyIxMDQiXX19'
      },
      {
        Icon: (
          <NewPriceIcon
            isInRestrictedState={isInRestrictedState}
            className="small-icon fill-blue-6"
          />
        ),
        title: isInRestrictedState ? 'New Price' : 'Price Drops',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7InRhZ0lkcyI6WyIxMDMiXX19'
      },
      {
        Icon: <FreeShippingIcon />,
        title: 'Free Shipping',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7ImlzRnJlZURlbGl2ZXJ5Ijp0cnVlfX0'
      },
      {
        Icon: <FilledPlugIcon />,
        title: 'Clean Vehicle Tax Credit',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7InRhZ0lkcyI6WyIxMTYiXX19'
      },
      {
        Icon: <SuggestedImage vehicle="electric" />,
        title: 'Electric',
        link: '/cars/electric'
      },
      {
        Icon: <SuggestedImage vehicle="hybrid" />,
        title: 'Hybrids',
        link: '/cars/hybrid'
      },
      {
        Icon: <SuggestedImage vehicle="suv" />,
        title: 'SUVs',
        link: '/cars/suv'
      },
      {
        Icon: <SuggestedImage vehicle="sedan" />,
        title: 'Sedans',
        link: '/cars/sedan'
      },
      {
        Icon: <SuggestedImage vehicle="truck" />,
        title: 'Trucks',
        link: '/cars/truck'
      },
      {
        Icon: <SuggestedImage vehicle="plug-in-hybrid" />,
        title: 'Plug-in Hybrids',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7ImZ1ZWxUeXBlcyI6WyJQbHVnLUluIEh5YnJpZCJdfX0'
      },
      {
        title: 'Cars Under $20,000',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7InByaWNlIjp7Im1heCI6MjAwMDB9fX0'
      },
      {
        title: 'Fuel Efficient',
        link: '/cars/filters?cvnaid=eyJmaWx0ZXJzIjp7Im1wZyI6eyJtaW4iOjMwfX19'
      }
    ],
    [isInRestrictedState]
  );
}
